import { defineComponent as _defineComponent } from 'vue'
import { IOption } from "@/domain/entities/filter/filter.types";
import { BookRequiredType } from "@/types";
import { PropType, computed } from "vue";
import InlineSvg from "vue-inline-svg";


const __default__ = {
  name: "LineSearchFilterSummary",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  searchParamsMap: {
    type: Map as PropType<Map<string, IOption | IOption[] | null>>,
    required: true,
  },
  bookRequiredType: {
    type: String as PropType<BookRequiredType>,
    required: true,
  },
},
  emits: ["onClickFilter", "onClickDeleteFilter"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;

const emit = __emit;

const FILTER_KEYS = {
  CAMPUS: "campusCodes",
  DATE: "driveDate",
  TIME_TYPE: "lineTimeCodes",
  DIRECTION: "lineDirectionCodes",
  DISTRICT: "lineDistrictCodes",
  WEEKDAY: "weekdayCodes",
  TIME: "searchDtm",
  TIME_FROM: "beginStationTimeFrom",
  TIME_TO: "beginStationTimeTo",
  BOOK: "bookYn",
};

const filtersMap: Map<string, string> = new Map([
  [FILTER_KEYS.CAMPUS, "캠퍼스"],
  [FILTER_KEYS.DATE, "오늘"],
  // [FILTER_KEYS.BOOK, "예약"],
  [FILTER_KEYS.TIME_TYPE, "노선형태"],
  [FILTER_KEYS.DIRECTION, "방향"],
  [FILTER_KEYS.DISTRICT, "지역"],
  // [FILTER_KEYS.WEEKDAY, "요일"],
  [FILTER_KEYS.TIME, "시간"],
]);

const shouldShowFilter = (filter: [string, string]) => {
  if (filter[0] !== FILTER_KEYS.BOOK) return true;
  return props.bookRequiredType === BookRequiredType.MIXED;
};

const getFilterValueForTime = () => {
  const fromDtm = props.searchParamsMap.get(FILTER_KEYS.TIME_FROM) as
    | IOption
    | undefined;
  const toDtm = props.searchParamsMap.get(FILTER_KEYS.TIME_TO) as
    | IOption
    | undefined;

  return fromDtm && toDtm
    ? `${fromDtm.value} ~ ${toDtm.value}`
    : filtersMap.get(FILTER_KEYS.TIME);
};

const getFilterValueForMultipleOptions = (
  key: string,
  selectedOptions: IOption[]
) => {
  const optionsLength = selectedOptions.length;

  if (!optionsLength) return filtersMap.get(key);

  if (key === FILTER_KEYS.WEEKDAY) {
    return optionsLength > 1
      ? `요일 ${selectedOptions.length}`
      : selectedOptions[0].name;
  }

  return optionsLength > 1
    ? selectedOptions.length.toString()
    : selectedOptions[0].name;
};

const getFilterValue = (key: string) => {
  if (key === FILTER_KEYS.TIME) return getFilterValueForTime();

  const selectedOptions = props.searchParamsMap.get(key);
  if (!selectedOptions) return filtersMap.get(key);

  if (Array.isArray(selectedOptions)) {
    return getFilterValueForMultipleOptions(key, selectedOptions);
  }

  if (selectedOptions.default) return filtersMap.get(key);

  return selectedOptions.name;
};

const isSelected = (key: string) => {
  if (key === FILTER_KEYS.TIME) {
    return (
      !!props.searchParamsMap.get(FILTER_KEYS.TIME_FROM) ||
      !!props.searchParamsMap.get(FILTER_KEYS.TIME_TO)
    );
  }

  const selectedOptions = props.searchParamsMap.get(key);
  if (selectedOptions) {
    // default 옵션은 선택된거 아님
    return Array.isArray(selectedOptions)
      ? !selectedOptions[0]?.default
      : !selectedOptions.default;
  } else {
    return false;
  }
};

const getFilterLabel = (key: string) => {
  return "필터 열기";
  // return isSelected(key)
  //   ? `필터 삭제 ${getFilterValue(key)}`
  // : '필터 열기';
};

const onClickFilter = (key: string) => {
  emitOnClickFilter();
  // isSelected(key) ? emitDeleteFilter(key) : emitOnClickFilter();
};

const emitOnClickFilter = () => {
  emit("onClickFilter");
};

const emitDeleteFilter = (key: string) => {
  if (key === FILTER_KEYS.TIME) {
    emit("onClickDeleteFilter", FILTER_KEYS.TIME_FROM);
    emit("onClickDeleteFilter", FILTER_KEYS.TIME_TO);
  } else {
    emit("onClickDeleteFilter", key);
  }
};

// 기본값이 아닌 필터가 하나라도 적용되었는지 확인
const hasAppliedFilters = computed(() => {
  for (const [key, value] of props.searchParamsMap) {
    // 날짜는 항상 기본값으로 취급 (오늘)
    if (key === FILTER_KEYS.DATE) continue;

    if (value) {
      if (Array.isArray(value)) {
        // 배열이면서 기본값이 아닌 항목이 있는지 확인
        if (value.length > 0 && !value[0]?.default) {
          return true;
        }
      } else {
        // 단일 값이면서 기본값이 아닌지 확인
        if (!value.default) {
          return true;
        }
      }
    }
  }

  // 시간 필터는 별도 처리
  if (
    props.searchParamsMap.get(FILTER_KEYS.TIME_FROM) ||
    props.searchParamsMap.get(FILTER_KEYS.TIME_TO)
  ) {
    return true;
  }

  return false;
});

const __returned__ = { props, emit, FILTER_KEYS, filtersMap, shouldShowFilter, getFilterValueForTime, getFilterValueForMultipleOptions, getFilterValue, isSelected, getFilterLabel, onClickFilter, emitOnClickFilter, emitDeleteFilter, hasAppliedFilters, get InlineSvg() { return InlineSvg } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})